__turbopack_context__.v({
  "iframeBlock": "f7nEuG_iframeBlock",
  "iframeContainer": "f7nEuG_iframeContainer",
});
